import { render } from "./HomeIcon.vue?vue&type=template&id=fe96351e&scoped=true&ts=true"
import script from "./HomeIcon.vue?vue&type=script&lang=ts"
export * from "./HomeIcon.vue?vue&type=script&lang=ts"

import "./HomeIcon.vue?vue&type=style&index=0&id=fe96351e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe96351e"]])

export default __exports__